import CryptoJS from 'crypto-js';

export default function digest(text: string): string {
    return CryptoJS.SHA256(text).toString(CryptoJS.enc.Hex);
}
